import { useNavigationContext } from '../../../contexts/NavigationContext';
import ProjectPage from './Project/ProjectPage';
import ProductPage from './Product/ProductPage';
import './DejaDemain.scss';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout scope={'dejademain'} websiteLabel={"dejademain-scenographie.fr"}>
      <ProjectPage isActive={navigationContext.activeAppKey === 'ddproject'} />
      <ProductPage isActive={navigationContext.activeAppKey === 'ddproduct'} />
    </MainLayout>
  );
}

export default Home;
